const STORAGE_KEY = "mogame_kb_project_hints";

function readHints() {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
  } catch {
    return {};
  }
}

function writeHints(hints) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(hints));
}

export function markKbProjectHint(gameId) {
  if (!gameId) return;
  const hints = readHints();
  hints[String(gameId)] = true;
  writeHints(hints);
}

export function isKbProjectHint(gameId) {
  if (!gameId) return false;
  return Boolean(readHints()[String(gameId)]);
}

export function clearKbProjectHint(gameId) {
  if (!gameId) return;
  const hints = readHints();
  delete hints[String(gameId)];
  writeHints(hints);
}
